import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { urtoast } from "../../Layouts/CustomPopup/eventEmitter";
import { v4 as uuidv4 } from "uuid";
import DisplayFileProper from "../FilesRelevent/DisplayFileProper";
import { validDocumentTypes, validImageTypes } from "../../../assests/extention/fileextention";
import { useFileValidator } from "../../../hooks/useFileValidator";
import UploadLoader from "../Loader/UploadLoader";

const ALLOWED_TYPES = [
  ...validImageTypes,
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/zip",
];

export default function AllTypeFilesUpload({
  formik,
  selectedfiles = [],
  setWork_sample,
}) {
  const [selectedFiles, setSelectedFiles] = useState(selectedfiles);
  const { validating, validateFiles } = useFileValidator();

  useEffect(() => {
    setSelectedFiles(selectedfiles);
  }, []);

  const handleUpload = async (files) => {
    // 🛡️ Validate all files via backend API
    const isValid = await validateFiles(files);
    if (!isValid) return;

    const uploadPromises = files.map((file) => {
      if (file.size > 10 * 1024 * 1024) {
        urtoast(`File size exceeds 10MB limit.`);
        return Promise.reject(new Error("File size exceeds limit."));
      }

      const uniqueId1 = uuidv4(); // Generate a unique ID for each file
      const storageRef = ref(
        getStorage(),
        `/Category/${uniqueId1}_${file.name}`,
      );
      const uploadTask = uploadBytesResumable(storageRef, file);
      return uploadTask
        .then(async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          return { file: url };
        })
        .catch((error) => {
          urtoast(`Error uploading ${file.name}: ${error.message}`);
          throw error;
        });
    });

    Promise.all(uploadPromises)
      .then((urls) => {
        const updatedFiles = [...selectedFiles, ...urls];
        setSelectedFiles(updatedFiles);
        setWork_sample((prevData) => ({
          ...prevData,
          files: updatedFiles,
        }));
        formik?.setFieldValue("files", updatedFiles);
      })
      .catch((error) => {
        console.error("Error uploading files: ", error);
      });
  };
  const onDrop = (acceptedFiles) => {
    handleUpload(acceptedFiles);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
      'application/vnd.ms-excel': ['.xls'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/vnd.ms-powerpoint': ['.ppt'],
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
      'application/zip': ['.zip'],
      'application/x-zip-compressed': ['.zip'],
      'text/plain': ['.txt'],
    }
  });

  const handleDeleteImage = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
    setWork_sample((prevData) => ({
      ...prevData,
      files: updatedFiles,
    }));
    formik?.setFieldValue("files", updatedFiles);
  };

  return (
    <div className="add-portfolio position-relative">
      {validating && <UploadLoader />}
      <div className="row">
        {selectedFiles.length === 0 ? (
          <div className="col-md-5">
            <div className="image-container">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/file-upload.png`}
                className="cover-img w-100"
                alt="Certificate"
              />
              {/* <button>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                  alt=""
                />
              </button> */}
            </div>
          </div>
        ) : (
          selectedFiles.map((item, index) => (
            <div key={index} className="image-container col-md-4 ">
              <DisplayFileProper item={item} />
              <button
                type="button"
                className="delete-button"
                onClick={() => handleDeleteImage(index)}
              >
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                  alt="Delete"
                />
              </button>
            </div>
          ))
        )}
      </div>
      <div
        {...getRootProps({ className: "dropzone borderstylex" })}
        className="drag-drop"
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the files here...</p>
        ) : (
          <p>
            Drag and drop or <span>Browse file</span>
          </p>
        )}
      </div>
      <ul className="border-ul">
        <li>Images (JPG, PNG, JPEG up to 10MB)</li>
        <li>Documents (PDF, DOCX, XLSX, PPTX, ZIP upto 10MB)</li>
      </ul>
    </div>
  );
}
